var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgGroup10000017281 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.3433,
    cy: 12.3433,
    r: 11.9176,
    stroke: "#00999E",
    strokeWidth: 0.85126
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5868 6.81C9.17568 6.81 6.38477 9.6059 6.38477 13.0494C6.38477 16.1629 8.65471 18.7471 11.6193 19.2141V14.8552H10.044V13.0494H11.6193V11.6732C11.6193 10.1103 12.5434 9.25096 13.9636 9.25096C14.6397 9.25096 15.3467 9.36927 15.3467 9.36927V10.9073H14.5652C13.7962 10.9073 13.5543 11.3868 13.5543 11.8787V13.0494H15.2785L14.9994 14.8552H13.5543V19.2141C15.0158 18.9823 16.3466 18.2337 17.3065 17.1032C18.2664 15.9727 18.7921 14.5349 18.7888 13.0494C18.7888 9.6059 15.9979 6.81 12.5868 6.81Z",
    fill: "#00999E"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgGroup10000017281);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Group 1000001728 (1).28f4469edf1c6910193c0ded42c2e9ac.svg";